var map = {
	"./10.png": 1700,
	"./11.png": 8085,
	"./12.png": 755,
	"./13.png": 592,
	"./14.png": 3986,
	"./15.png": 5346,
	"./16.png": 6432,
	"./17.png": 3332,
	"./18.png": 6031,
	"./19.png": 6326,
	"./creation2.png": 2179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3116;